import * as XLSX from "xlsx";

import renderHandlebarsTemplate from "../handlebars/renderHandlebarsTemplate";

export default async function generateExcelFromTemplate({
	document,
	domParser = (html) => {
		const { JSDOM } = require("jsdom");
		const dom = new JSDOM(html);
		return dom.window.document;
	},
	type = "binary",
}) {
	const { excelTemplate } = document.channel;
	const html = renderHandlebarsTemplate({ template: excelTemplate, data: document });
	const doc = domParser(html);
	const table = doc.querySelector("table");

	const rows = Array.from(table.querySelectorAll("tr")).map((tr) =>
		Array.from(tr.querySelectorAll("th, td")).map((cell) => {
			let text = cell.textContent || "";

			// Normalize line breaks
			text = text.replace(/\r?\n/g, "\n").trim();

			//dont line break for ; or ,
			text = text.replace(/([;,])\s*\n\s*/g, "$1 ");

			return text;
		}),
	);

	// Create worksheet from the array
	const worksheet = XLSX.utils.aoa_to_sheet(rows);

	const workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(workbook, worksheet, "Blad1");

	// Write the workbook
	return XLSX.write(workbook, {
		bookType: "xlsx",
		type,
		cellStyles: true,
	});
}
